import * as React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button,
  TextField,
  Box,
  Grid,
  Typography,
  FormControl,
} from '@mui/material';
import logoIcon from '../../../../assets/common-assets/docu-transcribe-logo(1).png';
import wavingHand from '../../../../assets/common-assets/wavingHand.png';
import '../common/commonCss.css';
import {
  REGISTER,
  INVALID_INPUT_REGEX,
  getHelperText,
  // INVALIDDOMAIN,
} from '../../../../constants/staticContent';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';

const FirstStepRegistration = ({
  formData,
  setFormData,
  errors,
  setErrors,
  nextStep,
  token,
}) => {
  const validateFirstName = (fname) => {
    const firstNameRegex = INVALID_INPUT_REGEX.NAME;
    return firstNameRegex.test(fname);
  };
  const validateLastName = (lname) => {
    const lastNameRegex = INVALID_INPUT_REGEX.NAME;
    return lastNameRegex.test(lname);
  };
  const validatePhone = (phone) => {
    const phoneRegex = INVALID_INPUT_REGEX.PHONE_NO;
    return phoneRegex.test(phone);
  };
  const validateEmail = (email1) => {
    const emailRegex = INVALID_INPUT_REGEX.EMAIL;
    return emailRegex.test(email1);
  };

  // const validateEmailDomain = (email) => {
  //   const domain = email.split('@')[1];
  //   return !INVALIDDOMAIN.includes(domain);
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const ValidateValue = name === 'phoneNo' ? value.replace(/\D/g, '') : value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: ValidateValue,
    }));

    if (
      name === 'firstName' ||
      name === 'lastName' ||
      name === 'email' ||
      name === 'phoneNo' ||
      (!token && name === 'email')
    ) {
      const isValidFname = validateFirstName(value);
      const isValidLname = validateLastName(value);
      const isValidPhone = validatePhone(ValidateValue);
      const isValidEmail =
        !token && name === 'email' ? validateEmail(value) : true;
      // const isValidEmailDomain = !token && name === 'email' ? validateEmailDomain(value) : true;
      setErrors((prevErrors) => ({
        ...prevErrors,
        firstName: name === 'firstName' ? !isValidFname : prevErrors.firstName,
        lastName: name === 'lastName' ? !isValidLname : prevErrors.lastName,
        phoneNo: name === 'phoneNo' ? !isValidPhone : prevErrors.phoneNo,
        email: name === 'email' ? !isValidEmail : prevErrors.email,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fnameValid = validateFirstName(formData.firstName);
    const lnameValid = validateLastName(formData.lastName);
    const phoneValid = validatePhone(formData.phoneNo);

    const errorsList = {
      firstName: !fnameValid,
      lastName: !lnameValid,
      phoneNo: !phoneValid,
    };

    if (!token) {
      const emailValid = validateEmail(formData.email);
      // const isValidEmailDomain = validateEmailDomain(formData.email);

      if (!emailValid) {
        errorsList.email = 'Invalid email format';
      } else {
        errorsList.email = '';
      }
      //  else if (!isValidEmailDomain) {
      //   errorsList.email = 'Email domain is not allowed';
      // }
    }
    setErrors(errorsList);
    if (fnameValid && lnameValid && phoneValid && !errorsList.email) {
      nextStep();
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6.5}
      lg={7.5}
      className={classes.rightGridForBothStep}
    >
      <Box className={classes.rightGridMainBoxForBothStep}>
        <Box
          className={classes.logoBox}
          component="img"
          src={logoIcon}
          alt="logoIcon"
        />

        <Typography className={classes.welcomeHeader} variant="h4">
          {REGISTER.WELCOME_TEXT.TITLE}
          <Box
            component="img"
            className="waving-hand"
            src={wavingHand}
            alt="wavingHand"
          />
        </Typography>

        <Typography
          variant="subtitle1"
          className={classes.rightBoxInfoSubtitleStepOne}
          color={lightPalette.carbonFiber.semiDark}
        >
          {REGISTER.WELCOME_TEXT.INFO}
        </Typography>

        <Box
          component="form"
          noValidate
          onSubmit={handleSubmit}
          className={classes.submitButton}
        >
          <FormControl className={classes.formControl}>
            <TextField
              className={classes.formAllTextFieldStepOne}
              required
              label="First Name"
              id="firstName"
              name="firstName"
              autoComplete="firstName"
              onChange={handleInputChange}
              value={formData.firstName}
              error={errors.firstName}
              helperText={getHelperText(
                'firstName',
                'firstName',
                errors,
                formData,
              )}
              autoFocus
            />

            <TextField
              className={classes.formAllTextFieldStepOne}
              required
              label="Last Name"
              id="lastName"
              name="lastName"
              autoComplete="lastName"
              onChange={handleInputChange}
              value={formData.lastName}
              error={errors.lastName}
              helperText={getHelperText(
                'lastName',
                'lastName',
                errors,
                formData,
              )}
            />

            {token ? (
              <TextField
                className={classes.formAllTextFieldStepOne}
                disabled
                required
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                variant="filled"
                InputProps={{
                  readOnly: true,
                }}
                value={formData.email}
              />
            ) : (
              <TextField
                className={classes.formAllTextFieldStepOne}
                required
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                onChange={handleInputChange}
                value={formData.email}
                error={errors.email}
                helperText={getHelperText('email', 'email', errors, formData)}
              />
            )}
            <TextField
              className={classes.formAllTextFieldStepOne}
              type="text"
              required
              name="phoneNo"
              label="Phone no"
              id="phoneNo"
              onChange={handleInputChange}
              value={formData.phoneNo}
              error={errors.phoneNo}
              helperText={getHelperText('phoneNo', 'phoneNo', errors, formData)}
              autoComplete="phoneNo"
            />

            <Button
              type="submit"
              variant="contained"
              className={classes.continueButtonStepOne}
            >
              <Typography variant="h5">{REGISTER.CONTINUE_BUTTON}</Typography>
            </Button>

            <Typography variant="body1" className={classes.registerTypo}>
              {REGISTER.LOGIN_LINK.TEXT}

              <Link to="/login" className={classes.loginLink}>
                {REGISTER.LOGIN_LINK.LINK}
              </Link>
            </Typography>
          </FormControl>
        </Box>
      </Box>
    </Grid>
  );
};

FirstStepRegistration.propTypes = {
  formData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNo: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
    email: PropTypes.bool,
    phoneNo: PropTypes.bool,
  }).isRequired,
  setErrors: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  token: PropTypes.string,
};

FirstStepRegistration.defaultProps = {
  token: null,
};

export default FirstStepRegistration;
